"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FeatureFlagged = void 0;
const FeatureStatus_1 = __importDefault(require("@opsbase/lib-system/FeatureStatus"));
const useSelf_1 = __importDefault(require("@opsbase/react-ctrl-self/useSelf"));
const react_1 = __importStar(require("react"));
function FeatureFlagged(props) {
    const { flag, children } = props;
    const self = (0, useSelf_1.default)();
    const { features } = self;
    const featureResolver = (0, react_1.useCallback)((f) => { var _a; return ((_a = features.find(z => z.name === f)) === null || _a === void 0 ? void 0 : _a.state) === FeatureStatus_1.default.ENABLED; }, [features]);
    let featureEnabled = (0, react_1.useMemo)(() => {
        // IF NO FLAG PROVIDED ... STATUS IS ENABLED
        if (!flag) {
            return true;
        }
        // GET FEATURE STATUS
        else if (features) {
            return typeof flag === 'function' ? flag(self, featureResolver) : featureResolver(flag);
        }
        return false;
    }, [featureResolver, features, flag, self]);
    // ENABLED
    if (featureEnabled) {
        if (!!children) {
            return children;
        }
        else {
            return react_1.default.createElement(react_1.Fragment, null);
        }
    }
    // HIDDEN
    else {
        return react_1.default.createElement(react_1.Fragment, null);
    }
}
exports.FeatureFlagged = FeatureFlagged;
exports.default = FeatureFlagged;
